import { gql } from '@apollo/client';
export default gql`
  query getOperationFinances($start: Date, $end: Date) {
    getOperationFinances(start: $start, end: $end) {
      ok
      error
      count
      data {
        _id
        docNo

        time
        opType
        title
        desc

        costAmount
        total
        discount
        amount

        refNo
        refType

        invoiceitems
        attachments

        supplierId
        supplierName
        supplierNameAr

        customerId
        customerName
        customerNameAr

        userId

        createdAt
        updatedAt
      }
    }
  }
`;
